import React from 'react';
import Dropdown from '../dropdown';
import DropdownButton from '../dropdown/dropdown-button';
import warning from 'antd/es/_util/warning';
const OverflowMenu = (props) => {
    if (process.env.NODE_ENV !== 'production')
        warning(false, 'OverflowMenu', '`OverflowMenu` is deprecated，use `Dropdown`.');
    return React.createElement(Dropdown, { ...props });
};
OverflowMenu.Button = DropdownButton;
export { OverflowMenu };
export default OverflowMenu;
